"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UITypeaheadResultsItem = _interopRequireDefault(require("UIComponents/typeahead/results/UITypeaheadResultsItem"));

var _default = _react.default.createClass({
  displayName: "TokenResultItem",
  propTypes: {
    option: _react.PropTypes.object.isRequired,
    highlighted: _react.PropTypes.bool.isRequired,
    disabled: _react.PropTypes.bool,
    onMouseDown: _react.PropTypes.func
  },
  handleMouseDown: function handleMouseDown(e) {
    var _this$props = this.props,
        option = _this$props.option,
        onMouseDown = _this$props.onMouseDown;
    e.preventDefault();
    e.stopPropagation();

    if (onMouseDown) {
      onMouseDown(option);
    }
  },
  render: function render() {
    var _this$props2 = this.props,
        option = _this$props2.option,
        highlighted = _this$props2.highlighted,
        disabled = _this$props2.disabled;
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      highlighted: highlighted,
      disabled: disabled,
      option: option,
      onMouseDown: this.handleMouseDown,
      "aria-pressed": true
    });
  }
});

exports.default = _default;
module.exports = exports.default;